import { useEffect, useState, useMemo, useCallback } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton, Stack, Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFUpload } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';

export const NewsLetterImageModal = ({ open, onClose, reload, currentItem, closeform, }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);

    const NewDocumentSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        description: Yup.string().required('Description is required'),
        // file: Yup.array().min(1, 'Images is required'),

    });

    const defaultValues = useMemo(
        () => ({


        }),
        []
    );


    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        setValue,
        watch,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const values = watch();

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const handleDrop = useCallback(
        (acceptedFiles) => {
            const files = values.images || [];

            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );

            setValue('files', [ ...files, ...newFiles ], { shouldValidate: true });
        },
        [ setValue, values.images ]
    );

    const handleRemoveFile = useCallback(
        (inputFile) => {
            const filtered = values.images && values.images?.filter((file) => file !== inputFile);
            setValue('files', filtered);
        },
        [ setValue, values.images ]
    );

    const handleRemoveAllFiles = useCallback(() => {
        setValue('files', []);
    }, [ setValue ]);



    const onSubmit = handleSubmit(async (data) => {
        console.log("🚀 ~ onSubmit triggered:", data);
        setLoading(true);
        const formData = new FormData();
        if (Array.isArray(data.files)) {
            data.files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });
        }
        console.log("🚀 ~ FormData values:", formData);
        try {
            const response = await postRequest(
                endpoints.admin_dashboard.product_updates.newsletter.post_modal_images,
                formData,
                true
            );
            console.log("🚀 ~ API Response:", response);
            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Upload Images &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Stack spacing={ 1.5 }>
                        <Typography variant="subtitle2">Images</Typography>

                        <RHFUpload
                            multiple
                            thumbnail
                            name="files"
                            maxSize={ 3145728 }
                            onDrop={ handleDrop }
                            onRemove={ (inputFile) =>
                                setValue(
                                    'files',
                                    values.files && values.files?.filter((file) => file !== inputFile),
                                    { shouldValidate: true }
                                )
                            }
                            // onRemoveAll={ () => setValue('files', [], { shouldValidate: true }) }
                            onUpload={ () => isSubmitting }
                        />
                    </Stack>
                </DialogContent>
                {/* <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Upload
                    </LoadingButton>
                </DialogActions> */}
            </FormProvider>
        </Dialog >
    );
};